import React from 'react'

const YouTubeFeed = () => {
    return (
        <>
            <iframe src="https://www.youtube.com/embed/?listType=user_uploads&list=@khetivalah" width="340" height="500" style={{ border: 'none', overflow: 'hidden' }} scrolling="no" frameBorder={0} allowFullScreen allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
        </>)
}

export default YouTubeFeed